export const PERMISSIONS = {
  FULL: "full",
  CB: "cb",
  CB_DELETE: "cb_delete",
  MERCH_VIEWER: "merch_viewer",
  MERCH_MANAGER: "merch_manager",
  MERCH_EDITOR: "merch_editor",
};
